import React from 'react'
import FixedDropdown from './FixedDropdown'
import { Okpd2 } from '../../../../Org/Handbook/types'
import { OrganizationInfo } from '../../../../Org/Home/types'

type Props = {
    anchorEl: HTMLElement | null
    open: boolean
    onClose: () => void
    items: Okpd2[]
    theme: string
    onPick: (it: Okpd2) => void

    // для правил
    orgDataIsComplianceSmb: boolean
    orgDataIgnoreMspOkpd2: boolean
    orgDataAllOkpd2: boolean

    posMSPStatus: boolean | null
    purchaseMethodCode: number | null
    isFirstSelected: boolean
    rowsCount: number
}

const isCodeAllLetters = (code?: string) => !!code && /^[A-Z]+$/.test(code)

const canPick = (
    item: Okpd2,
    posMSPStatus: boolean | null,
    purchaseMethodCode: number | null,
    isFirstSelected: boolean,
    rowsCount: number,
    orgDataIsComplianceSmb: boolean,
    orgDataIgnoreMspOkpd2: boolean,
    orgDataAllOkpd2: boolean
) => {
    if (isCodeAllLetters(item.code)) return false

    if (
        orgDataIsComplianceSmb &&
        posMSPStatus === true &&
        item.is_msp !== true
    ) {
        return false
    }

    if (orgDataIgnoreMspOkpd2) {
        if (orgDataAllOkpd2) return !!item.is_leaf
        return true
    }

    if (orgDataAllOkpd2 === false) {
        if (
            (purchaseMethodCode === 0 || purchaseMethodCode == null) &&
            !isFirstSelected
        )
            return true
        return item.is_msp === posMSPStatus
    }

    if (!item.is_leaf) return false
    if (
        (purchaseMethodCode === 0 || purchaseMethodCode == null) &&
        !isFirstSelected &&
        rowsCount > 0
    )
        return true
    return item.is_msp === posMSPStatus
}

const Okpd2Dropdown: React.FC<Props> = (p) => {
    return (
        <FixedDropdown
            anchorEl={p.anchorEl}
            open={p.open}
            onClose={p.onClose}
            minWidth={400}
            maxHeight={250}
            closeOnInsidePointerDown
        >
            <div
                onPointerDown={(e) => {
                    // если клик пришел НЕ по кнопке (пустое место/фон) — закрыть
                    const target = e.target as HTMLElement
                    const clickedButton = target.closest('button')
                    if (!clickedButton) {
                        e.stopPropagation()
                        p.onClose() // <-- закроется и в родителе сработает откат
                    }
                }}
            >
                {p.items.length ? (
                    p.items.map((it) => {
                        const allowed = canPick(
                            it,
                            p.posMSPStatus,
                            p.purchaseMethodCode,
                            p.isFirstSelected,
                            p.rowsCount,
                            p.orgDataIsComplianceSmb,
                            p.orgDataIgnoreMspOkpd2,
                            p.orgDataAllOkpd2
                        )
                        return (
                            <button
                                key={it.guid}
                                disabled={!allowed}
                                className={
                                    `w-full text-left px-2 py-1 text-[11px] ` +
                                    (allowed
                                        ? `hover:bg-[#e4e6e8] dark:hover:bg-[#373538] text-[#181818] dark:text-[#FFFFFF] cursor-pointer`
                                        : `bg-[#ebebeb] dark:bg-[#262427] text-[#6A6A6A] dark:text-[#8A8A8A] cursor-not-allowed`)
                                }
                                onPointerDown={(e) => {
                                    if (!allowed) return
                                    e.preventDefault() // не даём фокусам/blur закрыть список
                                    e.stopPropagation() // чтобы вне-клик не сработал
                                    p.onPick(it)
                                }}
                            >
                                <div className="flex items-start gap-2">
                                    <span className="shrink-0">{it.code}</span>
                                    <span className="whitespace-pre-wrap">
                                        {it.name}
                                    </span>
                                </div>
                            </button>
                        )
                    })
                ) : (
                    <div className="px-2 py-3 text-[#6A6A6A] dark:text-[#8A8A8A] text-[12px]">
                        Ничего не найдено
                    </div>
                )}
            </div>
        </FixedDropdown>
    )
}

export default Okpd2Dropdown
